import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { formatDistance, formatDuration } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';

@UntilDestroy()
@Component({
  selector: 'app-trip-card',
  templateUrl: './trip-card.component.html',
  styleUrls: ['./trip-card.component.css']
})
export class TripCardComponent implements OnInit {
  @Input() trips: any;
  @Input() selectedStatus: any;
  @Input() preLevelOfService: any;
  @Input() preSpacetypes: any;
  @Output() memberNotesObj = new EventEmitter<any>();
  @Output() tripDetails = new EventEmitter<any>();
  live:any;

  constructor(
    private tripService: TripService
  ) { }

  ngOnInit(): void {
    console.log('selectedStatus', this.selectedStatus);
  }

  checkLoaded(trip: any): void {
    const queryParam = {
      start: [trip.pickup.address.coords[0], trip.pickup.address.coords[1]].toString(),
      end: [trip.destination.address.coords[0], trip.destination.address.coords[1]].toString(),
    };

    this.tripService.calculateMiles(queryParam).pipe(untilDestroyed(this)).subscribe({
      next: (data: any) => {
        if (data) {
          const distance = data.features[0]?.properties?.segments[0]?.distance || 0;
          const duration = data.features[0]?.properties?.segments[0]?.duration || 0;
          const distanceValue = formatDistance(distance);
          const durationValue = formatDuration(duration);

          trip.loadedMiles = `${durationValue}`;
        }
      }, error: (err) => {
        sweetAlert("Error", 'Invalid Address', "error", "OK");
      }
    });

  }

  checkETA(trip: any): void {
    let startPoint, endPoint;
    startPoint = [trip.pickup.address.coords[0], trip.pickup.address.coords[1]];
    endPoint = [trip.destination.address.coords[0], trip.destination.address.coords[1]];


    if (trip.status == 'onway') {
      startPoint = [trip.tempDriver.longitude, trip.tempDriver.latitude];
      endPoint = [trip.pickup.address.coords[0], trip.pickup.address.coords[1]];
    }

    if (trip.status == 'in_progress' || trip.status == 'arrived') {
      startPoint = [trip.tempDriver.longitude, trip.tempDriver.latitude];
      endPoint = [trip.destination.address.coords[0], trip.destination.address.coords[1]];
    }

    const queryParam = {
      start: startPoint.toString(),
      end: endPoint.toString(),
    };

    this.tripService.calculateMiles(queryParam).pipe(untilDestroyed(this)).subscribe({
      next: (data: any) => {
        if (data) {
          const distance = data.features[0]?.properties?.segments[0]?.distance || 0;
          const duration = data.features[0]?.properties?.segments[0]?.duration || 0;
          const distanceValue = formatDistance(distance);
          const durationValue = formatDuration(duration);
          trip.etaTime = `${durationValue} and ${distanceValue}`;
        }
      }, error: (err) => {
        sweetAlert("Error", 'Invalid Address', "error", "OK");
      }
    });
  }

  isPastTime(time: string | Date): boolean {
    return moment(time).isBefore(moment());
  }

}
